module.exports = __webpack_public_path__ + "static/media/book-item-edit.e325df0f.svg";